import { Button } from "@/components/atoms/buttons";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { Plus } from "lucide-react";

type CreateWishlistButtonProps = {
  onClick?: () => void;
  locale: Locales;
};

const CreateWishlistButton = ({ onClick, locale }: CreateWishlistButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant="secondary"
      className="border-primary-light/50 h-11 w-full flex-1 rounded-sm bg-inherit text-base font-bold"
      size="md"
    >
      {__("Create a list", locale)}
      <Plus aria-hidden="true" size={20} />
    </Button>
  );
};

export default CreateWishlistButton;
